// 客服管理
export default [
  {
    path: "/customerService",
    meta: { title: "客服管理" },
    component: () => import("../views/customerService/index"),
  },
]
